module.exports = __webpack_public_path__ + "img/readingBook-pic1.193d3928.png";